import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { TrackerManagerModule } from '../../../../../components/tracker/tracker-manager/tracker-manager.module';
import { EditPatientGroupModalComponent } from './edit-patient-group-modal.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';

@NgModule({
  declarations: [EditPatientGroupModalComponent],
  imports: [
    CommonModule,
    NgxBootstrapIconsModule,
    ReactiveFormsModule,
    TrackerManagerModule,
    AccordionModule,
  ],
  exports: [EditPatientGroupModalComponent],
})
export class EditPatientGroupModalModule {}
